import { z } from "zod";

export const AdoptionJourneyInputSchema = z.object({
    dogId: z.string().min(1),
    dogPhoto: z.string(),
    breedName: z.string().min(1),
    breedSize: z.string().nullable(),
    breedEconomics: z.object({
        size: z.string().nullable(),
        monthlyCost: z.number().nonnegative().nullable(),
        energy: z.string().nullable(),
        shedding: z.enum(["minimal", "moderate", "heavy"]).nullable(),
        groomingFrequencyWeekly: z.number().nonnegative().nullable(),
    }),
});

export type AdoptionJourneyInput = z.infer<typeof AdoptionJourneyInputSchema>;

export const JourneyProgressSchema = z.array(z.string().min(1));

export type JourneyProgress = z.infer<typeof JourneyProgressSchema>;
